import axios from 'axios'
import { useMemo } from 'react'
import useEnvConfig from './useEnvConfig'

export default function useHttp() {
  const envConfig = useEnvConfig()

  return useMemo(
    () =>
      axios.create({
        baseURL: envConfig.API_PREFIX,
        timeout: 20000,
      }),
    [envConfig],
  )
}
